/* script */


const __vue_script__ = {

  /** @since 3.11.0 */
  name: 'modal-login',
  data() {
    return {
      show: false,
    }
  },

  computed: {

    login_url() {
      return window.initConfig.user.login_url;
    },

  },

  methods: {

    onIframeLoaded() {
      const iframe = this.$refs.login_iframe?.contentWindow;
      const user   = iframe?.initConfig?.user || iframe?.g3w?.state?.user;
      if (user?.logout_url && this.show) {
        this.show = false;
        window.location.reload();
      }
    },

  },

  async mounted() {
    document.body.appendChild(this.$el);
    await this.$nextTick();
    this.show = true;
  }

};


/* template */
var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('dialog',{staticStyle:{"width":"min(85vw, 600px)"},attrs:{"id":"modal-login","aria-label":_vm.$t('sign_in')}},[_c('form',{staticStyle:{"height":"60vh","padding":"0"},attrs:{"method":"dialog"}},[_c('button',{staticStyle:{"border":"none","line-height":"1","font-weight":"700","font-size":"25px","background":"none","position":"absolute","inset":"0 0 auto auto","width":"40px","height":"40px"},attrs:{"value":"cancel"}},[_vm._v("×")]),_vm._v(" "),_c('div',{staticStyle:{"height":"100%","background":"#d2d6de","display":"grid","grid-template-areas":"'iframe'","place-items":"center"}},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('Loading ...'),expression:"'Loading ...'"}],staticStyle:{"grid-area":"iframe"}}),_vm._v(" "),_c('iframe',{ref:"login_iframe",staticStyle:{"border":"0","width":"100%","height":"100%","grid-area":"iframe"},attrs:{"loading":"lazy","src":_vm.login_url,"title":"login form"},on:{"load":_vm.onIframeLoaded}})])])]):_vm._e()
}
var staticRenderFns = []

const __vue_render__ = render;
const __vue_staticRenderFns__ = staticRenderFns;

const __vue_component__ = __vue_script__;
__vue_component__.render = __vue_render__;
__vue_component__.staticRenderFns = __vue_staticRenderFns__;
__vue_component__._compiled = true;
__vue_component__.__file = "/home/volterra79/G3W-SUITE/g3w-client/src/components/ModalLogin.vue";

/* style inject */

export default __vue_component__;